export const languages = {
    'English': 'en',
    'Français': 'fr',
    'Deutsch': 'de',
}